import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import PcpReferralEsignHistoryView from '../components/views/pcpReferralEsignHistoryView'
import { Page, PageHeader } from '../ui'

function PcpReferralEsignHistory() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="PCP Referral"
                        title="eSign History"
                        intro="Every PCP Referral client touched by the engagement system — links sent, signatures captured, and new clients added to the database. Use the filters below to drill in and download CSV reports."
                    />
                    <PcpReferralEsignHistoryView />
                </Page>
            </MainView>
        </div>
    )
}

export default PcpReferralEsignHistory
